<template>
    <div :class="{ disabled_option: disabled }">
        <div class="row_center_end quantity_container" v-if="quantity !== 0">
            <div class="row_center_center quantity">{{ quantity }}</div>
        </div>
        <div class="row_center_between w-full">
            <div class="row_center_center" style="background-color: #DDDDDD; border-radius: 50%; padding: 2px;"
                @click="subtractQuantity">
                <text id="remove" class="button-icon"
                    style="color: #000; font-size: 32px; height: 32px; width: 32px">remove</text>
            </div>

            <div class="row_center_center px-1.5 grow w-0" @click="addQuantity">
                <text class="flex-wrap">{{ displayName }}</text>
                <text class="shrink-0" v-if="product['altAddonPrice'] !== undefined && product.altAddonPrice !== 0">{{
            formatPriceChange(product.altAddonPrice) }}</text>
                <!-- 一般商品規格價格 -->
                <text class="shrink-0" v-else-if="product['altAddonPrice'] === undefined && product.price !== 0 && !isProduct">{{
            product.price > 0 ? `+${product.price}` : product.price }}</text>
                <text class="stock_text" :class="{ sold_out: isSoldOut }" v-if="showStock">
                    {{ isSoldOut ? '售完' : `剩餘數量：${product.stockCount}` }}
                </text>
            </div>

            <div class="row_center_center" style="background-color: #FBCB02; border-radius: 50%; padding: 2px;"
                @click="addQuantity">
                <text id="add" class="button-icon"
                    style="color: #000; font-size: 32px; height: 32px; width: 32px">add</text>
            </div>
        </div>
    </div>
</template>
<script>
import { getFrontEndName, getSpecOptionFrontEndName } from "@/utils/productName.utils";
export default {
    props: {
        product: {
            type: Object,
            default: () => {
                return {};
            },
            required: true,
        },
        quantity: {
            type: Number,
            default: 0,
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        // true：此項為「規格選項」(基本名稱第1段)；false：為「商品/套餐子項」(前台顯示名稱第2段)
        isSpecOption: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        displayName() {
            return this.isSpecOption
                ? getSpecOptionFrontEndName(this.product.name)
                : getFrontEndName(this.product.name)
        },
        showStock() {
            return Number(this.product.stockMode) === 1 && this.product.stockCount !== null && this.product.stockCount !== undefined
        },
        isSoldOut() {
            return this.product.isStockSoldOut || Number(this.product.stockCount) === 0
        },
        isProduct() {
            return this.products.find(item => item.id === this.product.id)
        },
        products() {
            return this.$store.getters['spreadsheet/products']
        }
    },
    methods: {
        formatPriceChange(price) {
            return price > 0 ? `+${price}` : price
        },
        click() {
            this.$emit("click");
        },
        openCustomizePopup() {
            this.$emit("openCustomizePopup");
        },
        subtractQuantity() {
            this.$emit("subtractQuantity");
        },
        addQuantity() {
            if (this.disabled) return
            this.$emit("addQuantity");
        }
    }
}
</script>
<style lang="scss" scoped>
.quantity_container {
    width: 100%;
    height: 0px;
    position: relative;
}

.quantity {
    position: absolute;
    top: -22px;
    right: -25px;
    border-radius: 50%;
    width: 32px;
    height: 32px;
    background-color: #D60A0A;
    flex-shrink: 0;
    color: #fff;
    font-size: 18px;
    font-weight: 500;
    font-family: PingFang SC;
}

.stock_text {
    display: inline-block;
    margin-left: 8px;
    color: #666666;
    font-size: 14px;
}

.stock_text.sold_out {
    color: #D60A0A;
}

.disabled_option {
    opacity: 0.45;
}
</style>
